import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import { FcPivotModel } from '../../../models/forecast/fc-pivot-model';
import { FcvalidationlogService } from '../fcvalidationlog.service';
import notify from 'devextreme/ui/notify';
import { DxChartComponent, DxPivotGridComponent } from 'devextreme-angular';

@Component({
    selector: 'app-fcpivot',
    templateUrl: './fcpivot.component.html',
    styleUrls: ['./fcpivot.component.scss'],
    standalone: false
})

export class FcpivotComponent implements OnInit,AfterViewInit {
  FcParamCaption : any = [];
  FcValueCaption : any = [];
  temparray : any =[];
  pivotGridDataSource: any;
  applyChangesMode : any;
  state : any;
  layout : any;
  showDataFields: boolean = true;
  showRowFields: boolean = true;
  showColumnFields: boolean = true;
  showFilterFields: boolean = true;
  showfieldchooserPopUp : boolean = false;
  pivotsetting : FcPivotModel;
  withAnimationVisible = false;
  @ViewChild(DxPivotGridComponent, { static: false }) pivotGrid: DxPivotGridComponent;
  @ViewChild(DxChartComponent, { static: false }) chart: DxChartComponent;

  constructor(private FcLogSvc : FcvalidationlogService) {

    this.FcLogSvc.getFcPivotData().subscribe(resp =>{
      if(resp)
      {
        console.log(resp[0]);
        this.temparray = resp[0];
        resp[1].forEach(
            element => {

            this.FcParamCaption.push({'area':element.Area,'areaIndex':element.AreaIndex,'dataField':element.FieldName,
                                  'expanded':element.Expanded,'filterType':element.FilterType,'filterValues':element.FilterValues,
                                  'name':element.Name,'sortBy':element.SortBy,'sortBySummaryField':element.sortBySummaryField,
                                  'sortBySummaryPath':element.SortBySummaryPath,'sortOrder':element.SortOrder,
                                  'summaryDisplayMode':element.SummaryDisplayMode,'summaryType':element.SummaryType,'dataType':'',
                                  'caption': element.FieldCaption,'width': '30'});}
          );

        resp[2].forEach(element => {

          if(element.FieldName == "Period")
          {
            this.FcParamCaption.push({'area':element.Area,'areaIndex':element.AreaIndex,'dataField':element.FieldName,
            'expanded':element.Expanded,'filterType':element.FilterType,'filterValues':element.FilterValues,
            'name':element.Name,'sortBy':element.SortBy,'sortBySummaryField':element.sortBySummaryField,
            'sortBySummaryPath':element.SortBySummaryPath,'sortOrder':element.SortOrder,
            'summaryDisplayMode':element.SummaryDisplayMode,'summaryType':element.SummaryType,
            'caption': element.FieldCaption,'dataType':'number'});
          }
          else
          {
            this.FcParamCaption.push({'area':element.Area,'areaIndex':element.AreaIndex,'dataField':element.FieldName,
            'expanded':element.Expanded,'filterType':element.FilterType,'filterValues':element.FilterValues,
            'name':element.Name,'sortBy':element.SortBy,'sortBySummaryField':element.sortBySummaryField,
            'sortBySummaryPath':element.SortBySummaryPath,'sortOrder':element.SortOrder,
            'summaryDisplayMode':element.SummaryDisplayMode,'summaryType':element.SummaryType,
            'caption': element.FieldCaption,'dataType':'number','format':'#,##0.##'});
          }
        });


        this.customizeTooltip = this.customizeTooltip.bind(this);
        console.log(this.FcParamCaption);
          this.pivotGridDataSource = new PivotGridDataSource({
          fields: this.FcParamCaption,

          store:  resp[0]
          });
          this.layout = "Layout0";
          this.state = this.pivotGridDataSource.state();

      }
    });

   }

  ngOnInit() {


    this.applyChangesMode = "onDemand";

  }

   ngAfterViewInit() {
  }


  contextMenuPreparing(e) {
    let dataSource = e.component.getDataSource(),
        sourceField = e.field;

    if (sourceField) {
        if (!sourceField.groupName || sourceField.groupIndex === 0) {
            e.items.push({
                text: "Hide field",
                onItemClick: function () {
                    let fieldIndex;
                    if (sourceField.groupName) {
                        fieldIndex = dataSource.getAreaFields(sourceField.area, true)[sourceField.areaIndex].index;
                    } else {
                        fieldIndex = sourceField.index;
                    }

                    dataSource.field(fieldIndex, {
                        area: null
                    });
                    dataSource.load();
                }
            });
        }

        if (sourceField.dataType === "number") {
            let setSummaryType = function (args) {
                dataSource.field(sourceField.index, {
                    summaryType: args.itemData.value
                });

                dataSource.load();
            },
                menuItems = [];

            e.items.push({ text: "Summary Type", items: menuItems });

            for (let summaryType of ["Sum", "Avg", "Min", "Max"]) {
                let summaryTypeValue = summaryType.toLowerCase();

                menuItems.push({
                    text: summaryType,
                    value: summaryType.toLowerCase(),
                    onItemClick: setSummaryType,
                    selected: e.field.summaryType === summaryTypeValue
                });
            };
        }
    }
}

applyChanges()
{
  console.log('applyChanges');
  console.log(this.state.fields);
  this.pivotGridDataSource.state(this.state);
  this.showfieldchooserPopUp = false;
}

cancelChanges()
{
  this.state = this.pivotGridDataSource.state();
  this.showfieldchooserPopUp = false;
}

showfieldchooser()
{
  this.showfieldchooserPopUp = true;
}

toggleWithAnimation() {
  this.withAnimationVisible = !this.withAnimationVisible;
}
customizeTooltip(args) {
  return {
    html: args.seriesName + " | Total<div class='currency'>" + args.valueText + "</div>"
  };
}
savesettings()
{

  this.pivotsetting = this.state.fields;
  console.log('this.pivotsetting');
  console.log(this.pivotsetting);
  this.FcLogSvc.savePivotUserSettings(this.pivotsetting,'1').subscribe(resp =>{
    if(resp)
    {
      console.log(resp.response);
      notify(resp.response,"success",3000);

    }
  });
}
}
